import { API_URL, AUTH_URL } from "../constants"
import { AUTH_KEY } from "../context/authContext"
import { APIRequest, HTTPClient, RequestType } from "../services/http_client"
import LocalStorageService from "../services/localstorage.service"
import { Attachment } from "../types/attachment"

const client = new HTTPClient()

export interface ResponseArrayType {
    slideshow?: {
        data: Array<Attachment>;
    };
    error?: string;
}

export interface SavedResponseType {
    slideshow_id?: number;
    error?: string;
}

interface SaveSlideshow {
    slideshowId?: number | undefined;
    attachments: Array<Attachment>;
}

class SlideshowModel {
    static async find(slideshowId: number) {
        const request = new APIRequest(
            RequestType.GET,
            `${API_URL}/slideshow/${slideshowId}`,
            undefined,
          )
    
          const response = await client.get(request)
    
          if (!response.success) {
              return {
                  error: response.errorMessage,
              }
          }
    
          return response.result as unknown as ResponseArrayType
    }

    static async delete(slideshowId: number) {
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            RequestType.DELETE,
            `${AUTH_URL}/slideshow/${slideshowId}`,
            undefined,
            auth.accessToken
          )
    
          const response = await client.delete(request)
    
          if (!response.success) {
              return {
                  error: response.errorMessage,
              }
          }
    
        return true
    }

    static async save({slideshowId, attachments} : SaveSlideshow) {
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const requestType = slideshowId ? RequestType.PUT : RequestType.POST;
        const endpoint = slideshowId ? `${AUTH_URL}/slideshow/${slideshowId}` : `${AUTH_URL}/slideshow`

        const request = new APIRequest(
            requestType,
            endpoint,
            JSON.stringify({
                attachments
            }),
            auth.accessToken
          )
    
          const response = slideshowId ? await client.put(request) : await client.post(request)
    
          if (!response.success) {
              return {
                  error: response.errorMessage,
              }
          }
    
          return response.result as unknown as SavedResponseType
    }
}

export default SlideshowModel